/**
 * CHAT — the troll box, `docs/06` §F137.
 *
 * One room per asset. The room is **read from the `chat.{asset}` channel**;
 * `GET` is its REST counterpart, used for gap recovery and for scrolling back,
 * **never on a timer** — a channel exists, so polling it would break invariant 8.
 */

import type { HttpClient, MutationOptions, RequestOptions } from '../client'
import type { Asset } from '../../ws/protocol'
import type { OkBody, OpBody, OpQuery } from '../types'

export function chatEndpoints(client: HttpClient) {
  return {
    /** The room's newest messages, newest first; `before` pages back. */
    listChatMessages(asset: Asset, query?: OpQuery<'listChatMessages'>, options?: RequestOptions) {
      return client.get<OkBody<'listChatMessages'>>(`/chat/${asset}/messages`, { ...options, query })
    },

    /**
     * Posts one message under the session's username. **Not idempotent**: a
     * retried post may appear twice, so the caller never retries it on its own.
     */
    postChatMessage(asset: Asset, body: OpBody<'postChatMessage'>, options?: MutationOptions) {
      return client.post<OkBody<'postChatMessage'>>(`/chat/${asset}/messages`, body, options)
    },
  }
}

export type ChatEndpoints = ReturnType<typeof chatEndpoints>
